module.exports = require("core-js/modules/es.string.small.js");